import { render, staticRenderFns } from "./ColorChip.vue?vue&type=template&id=a30afcd0&scoped=true"
import script from "./ColorChip.vue?vue&type=script&lang=js"
export * from "./ColorChip.vue?vue&type=script&lang=js"
import style0 from "./ColorChip.vue?vue&type=style&index=0&id=a30afcd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30afcd0",
  null
  
)

export default component.exports